module.exports = __webpack_public_path__ + "app-static/img/10.4bbd5ba9.png";